import http from "./http";

export const API = {
  getCompanies: async () => {
    try {
      const res = await http.post("/companies/clients");
      const clients = await res.data;
      return clients;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  },

  postNewCompany: async (data) => {
    try {
      const res = await http.post("/companies/create", { ...data });
      const clients = await res.data;

      return clients;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  },

  putCompany: async (id, data) => {
    try {
      const res = await http.put(`/companies/${id}`, { ...data });
      const clients = await res.data;

      return clients;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  },

  deleteClient: async (id) => {
    try {
      const res = await http.delete(`/companies/${id}`);
      const schedules = await res.data;
      return schedules;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  },

  postSchedule: async (data) => {
    try {
      const res = await http.post("/schedule", { ...data });
      const schedules = await res.data;
      return schedules;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  },

  getSchedule: async () => {
    try {
      const res = await http.get("/schedule");
      const schedules = await res.data;
      return schedules;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  },

  putSchedule: async (id, data) => {
    try {
      const res = await http.put(`/schedule/${id}`, { ...data });
      const schedules = await res.data;
      return schedules;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  },

  deleteSchedule: async (id) => {
    try {
      const res = await http.delete(`/schedule/${id}`);
      const schedules = await res.data;
      return schedules;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  },

  // in-progress schedules

  patchInProgressSchedule: async (id, data) => {
    try {
      const res = await http.patch(`/schedule/in-progress/${id}`, { ...data });
      const schedules = await res.data;
      return schedules;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  },

  deleteInProgressSchedule: async (id) => {
    try {
      const res = await http.delete(`/schedule/in-progress/${id}`);
      const schedules = await res.data;
      return schedules;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  },

  getEmployees: async (clientId) => {
    try {
      const res = await http.post("/employee", { clientId });
      let employees = await res.data;

      return employees;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  },
  getDepartments: async () => {
    try {
      const res = await http.get("/departments");
      const departments = await res.data;
      return departments;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  },
  postDepartments: async (data) => {
    try {
      const res = await http.post("/departments", { ...data });
      const departments = await res.data;
      return departments;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  },

  putDepartments: async (id, data) => {
    try {
      const res = await http.put(`/departments/${id}`, { ...data });
      const departments = await res.data;
      return departments;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  },

  deleteDepartments: async (id) => {
    try {
      const res = await http.delete(`/departments/${id}`);
      const departments = await res.data;
      return departments;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  },

  getShifts: async () => {
    try {
      const res = await http.get("/shift");
      const shifts = await res.data;
      return shifts;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  },

  postShifts: async (data) => {
    try {
      const res = await http.post("/shift", { ...data });
      const shifts = await res.data;
      return shifts;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  },

  putShifts: async (id, data) => {
    try {
      const res = await http.put(`/shift/${id}`, { ...data });
      const shifts = await res.data;
      return shifts;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  },
  deleteShifts: async (id) => {
    try {
      const res = await http.delete(`/shift/${id}`);
      const shifts = await res.data;
      return shifts;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  },

  getAllColors: async () => {
    try {
      const res = await http.get(`/colors`);
      const colors = await res.data;
      return colors;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  },

  postColor: async (data) => {
    try {
      const res = await http.post("/colors", { ...data });
      const colors = await res.data;
      return colors;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  },

  putColor: async (id, data) => {
    try {
      const res = await http.put(`/colors/${id}`, { ...data });
      const colors = await res.data;
      return colors;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  },
  deleteColor: async (id) => {
    try {
      const res = await http.delete(`/colors/${id}`);
      const colors = await res.data;
      return colors;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  },

  getAllReports: async () => {
    try {
      const res = await http.get(`/report`);
      const reports = await res.data;
      return reports;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  },

  getReport: async (id, data) => {
    try {
      const res = await http.post(`/report/${id}`, { data });
      const reports = await res.data;
      return reports;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  },

  postReport: async (data) => {
    try {
      const res = await http.post("/report", { ...data });
      const report = await res.data;
      return report;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  },

  putReport: async (id, data) => {
    try {
      const res = await http.put(`/report/${id}`, { ...data });
      const report = await res.data;
      return report;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  },
  deleteReport: async (id) => {
    try {
      const res = await http.delete(`/report/${id}`);
      const report = await res.data;
      return report;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  },
};
